import { ICameraFilter } from '../../model/api/customers/camera-filter';
import { ICameraItem } from '../../model/api/customers/camera-item';
import { ICameraLookupItem } from '../../model/api/customers/camera-lookup-item';
import { ICustomerCameraFilter } from '../../model/api/customers/customer-camera-filter';

import { getCameraApi } from './api';

const URL = '/camera';

const getList = async (filter: ICameraFilter): Promise<{ data: Array<ICameraItem>; total: number }> => {
  let url = `${URL}?skip=${filter.skip}&take=${filter.take}`;

  if (filter.locationIds?.length) {
    url += `&${filter.locationIds?.map((x) => `locations=${x}`).join('&')}`;
  }

  if (filter.query?.length) {
    url += `&query=${filter.query}`;
  }

  if (filter.customer?.length) {
    url += `&customer=${filter.customer}`;
  }

  const api = await getCameraApi();
  return api
    .get<{ data: Array<ICameraItem>; total: number }>(url)
    .then((response) => response.data)
    .then((res) => {
      res.data.forEach((x) => (x.updatedAt = new Date(x.updatedAt)));
      return res;
    });
};

const getCustomerCamerasList = async (filter: ICustomerCameraFilter): Promise<Array<ICameraLookupItem>> => {
  let url = `${URL}/customer/${filter.customerId}/lookup-values`;

  if (filter.locationId) {
    url += `?locationId=${filter.locationId}`;
  }

  const api = await getCameraApi();
  return api
    .get<Array<ICameraLookupItem>>(url)
    .then((response) => response.data)
    .then((res) => {
      return res;
    });
};

export const camerasService = {
  getList,
  getCustomerCamerasList,
};
